import { Form, Select } from "antd";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectedPhoneNumberSelector } from "appredux/selectors";
import dayjs from "dayjs";
import AgentSelector from "./AgentSelector";
import ContactSelector from "../createChat/ContactSelector";
import PhoneNumberSelector from "./PhoneNumberSelector";
import { DateRangePicker } from "components/UI";
import TagSelector from "./TagSelector";
import { isEmpty } from "lodash-es";

const FilterChatFormComp = ({ data, ...props }) => {
  const { t } = useTranslation();
  const selectedPhoneNumber = useSelector(selectedPhoneNumberSelector);
  // Channel inhouse (tanpa waba_id): suggestion kontak dibatasi ke channel ini.
  const inhouseChannelId =
    selectedPhoneNumber && !selectedPhoneNumber.waba_id
      ? selectedPhoneNumber.id
      : undefined;

  const initialValues = useMemo(() => {
    let date = undefined;
    if (!isEmpty(data?.date_from) && !isEmpty(data?.date_to)) {
      date = [dayjs(data.date_from), dayjs(data.date_to)];
    }

    return {
      agent_id: data?.agent_id ? parseInt(data.agent_id, 10) : undefined,
      phone_number_id: data?.phone_number_id
        ? parseInt(data.phone_number_id, 10)
        : undefined,
      contact_id: data?.contact_id ? parseInt(data.contact_id, 10) : undefined,
      tag_ids: data?.tag_ids
        ? data?.tag_ids.split(",").map((id) => parseInt(id, 10))
        : undefined,
      conv_status_id:
        data?.conv_status_id !== null &&
        data?.conv_status_id !== undefined &&
        data?.conv_status_id !== ""
          ? data?.conv_status_id
          : "",
      date,
    };
  }, [data]);

  return (
    <Form
      layout="vertical"
      initialValues={initialValues}
      name="filterChat"
      className="px-2 bg-white"
      {...props}
    >
      <Form.Item className="mb-2" name="date" label="Periode">
        <DateRangePicker className="w-9/12" />
      </Form.Item>
      <ContactSelector
        className="mb-2"
        label={t("contact")}
        inhouseChannelId={inhouseChannelId}
      />
      <TagSelector className="mb-2" />
      <AgentSelector className="mb-2" />
      <PhoneNumberSelector className="mb-2" />
      <Form.Item className="mb-2" name="conv_status_id" label="Status">
        <Select
          options={[
            { label: t("all"), value: "" },
            { label: t("conversation.filter_open"), value: "0" },
            { label: t("conversation.filter_closed"), value: "1" },
          ]}
        />
      </Form.Item>
    </Form>
  );
};

const FilterChatForm = memo(FilterChatFormComp);

export default FilterChatForm;
